'use strict';

function CompanySettingUnitsService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/units/:unitId', {}, {
    'update': {method: 'PUT'},
    'queryMembers': {
      url: config.apiBase + '/companies/:companyId/units/:unitId/users',
      method: 'GET',
      isArray: true
    },
    'addMembers': {
      url: config.apiBase + '/companies/:companyId/units/:unitId/users',
      method: 'POST'
    },
    'deleteMember':  {
      url: config.apiBase + '/companies/:companyId/units/:unitId/users/:userId',
      method: 'DELETE'
    }
  });
}

angular.module('dokiv')
  .factory('CompanySettingUnitsService', ['$resource', 'config', CompanySettingUnitsService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingUnitsService.js
// module id = 417
// module chunks = 0